export type MusteriKayitDurum =
  | "Aktif"
  | "Kesim Bekliyor"
  | "Kesime Girdi"
  | "Kesim Yapıldı"
  | "Parçalanıyor"
  | "Hazır"
  | "Taşıma Halinde"
  | "Teslim Edildi"
  | "Tamamlandı";

export interface OdemeSatiri {
  tarih: string;
  miktar: number;
  aciklama: string;
}

export interface MusteriTeslimat {
  tasiyiciAdi: string;
  tasiyiciTelefon: string;
  arac?: string;
  durum: "Hazır" | "Taşıma Halinde" | "Teslim Edildi";
  hayvanKupeNo: string;
  hisseNo: string;
  adres: string;
  canliKonumLinki?: string;
  teslimSaati?: string;
  not?: string;
}

export interface MusteriKayit {
  id: number;
  hayvanKupeNo: string;
  hayvanTur: "Büyükbaş" | "Küçükbaş";
  hayvanKg: number;
  hisseNo: string;
  hisseSayisi: number;
  etTutari: number;
  kesimUcreti: number;
  parcalamaUcreti: number;
  tasimaUcreti: number;
  indirim: number;
  toplamTutar: number;
  odenen: number;
  kalan: number;
  durum: MusteriKayitDurum;
  kesimTarihi?: string;
  kesimSaati?: string;
  tamamlanmaTarihi?: string;
  teslimat?: MusteriTeslimat;
  odemeler: OdemeSatiri[];
}

export interface MusteriPaneliData {
  adSoyad: string;
  telefon: string;
  email?: string;
  aktifKayitlar: MusteriKayit[];
  tamamlananKayitlar: MusteriKayit[];
  teslimat?: MusteriTeslimat;
}

export const durumRenk: Record<
  MusteriKayitDurum,
  { badge: string; dot: string; label: string; icon: string }
> = {
  Aktif: {
    badge: "bg-gray-100 text-gray-600",
    dot: "bg-gray-400",
    label: "Aktif",
    icon: "ri-time-line",
  },
  "Kesim Bekliyor": {
    badge: "bg-amber-100 text-amber-700",
    dot: "bg-amber-400",
    label: "Kesim Bekliyor",
    icon: "ri-calendar-check-line",
  },
  "Kesime Girdi": {
    badge: "bg-orange-100 text-orange-700",
    dot: "bg-orange-500",
    label: "Kesim Sürüyor",
    icon: "ri-scissors-2-line",
  },
  "Kesim Yapıldı": {
    badge: "bg-lime-100 text-lime-700",
    dot: "bg-lime-500",
    label: "Kesim Yapıldı",
    icon: "ri-check-line",
  },
  Parçalanıyor: {
    badge: "bg-sky-100 text-sky-700",
    dot: "bg-sky-500",
    label: "Hazırlanıyor",
    icon: "ri-tools-line",
  },
  Hazır: {
    badge: "bg-blue-100 text-blue-700",
    dot: "bg-blue-400",
    label: "Teslimata Hazır",
    icon: "ri-box-3-line",
  },
  "Taşıma Halinde": {
    badge: "bg-amber-100 text-amber-800",
    dot: "bg-amber-500",
    label: "Yolda",
    icon: "ri-truck-line",
  },
  "Teslim Edildi": {
    badge: "bg-green-100 text-green-700",
    dot: "bg-green-500",
    label: "Teslim Edildi",
    icon: "ri-checkbox-circle-line",
  },
  Tamamlandı: {
    badge: "bg-farm-green-pale text-farm-green",
    dot: "bg-farm-green",
    label: "Tamamlandı",
    icon: "ri-check-double-line",
  },
};

export const musteriPaneliData: MusteriPaneliData = {
  adSoyad: "",
  telefon: "",
  aktifKayitlar: [],
  tamamlananKayitlar: [],
};
